import { useIntl } from 'react-intl'

import { PageWorkflowStatus } from 'shared/types/global'
import { DropdownOption } from 'shared/ui/Dropdown'
import PageStatus from 'shared/ui/PageStatus'

import {
  PAGE_STATUS_LABEL_IDS,
  SELECTABLE_PAGE_STATUSES
} from './constants'

export const usePageStatusOptions = (
  size = 16
): DropdownOption<PageWorkflowStatus>[] => {
  const { formatMessage } = useIntl()

  return SELECTABLE_PAGE_STATUSES.map(status => ({
    value: status,
    label: formatMessage({ id: PAGE_STATUS_LABEL_IDS[status] }),
    icon: <PageStatus status={status} size={size} />
  }))
}
